import SitePlannerEditor from "@/components/crm/SitePlannerEditor";

export default function CRMTekenaarEditor() {
  return <SitePlannerEditor />;
}
